module.exports = __webpack_public_path__ + "img/7868bc9.jpg";